import { Component, OnInit, TemplateRef } from '@angular/core';
import { BannerMessageVariant } from '@amobee/component-library';
import { Subscription } from 'rxjs';
import { MessageService } from '../../../services/message.service';

export interface INotificationMessage {
    text?: string,
    variant: BannerMessageVariant,
    timeout?: number,
    ignoreDuplicate?: boolean,
    dismissible?: boolean,
    customHtml?: {
        scopeValue?: any;
        templateRef: TemplateRef<any>;
    },
    isRemove?: boolean
}

@Component({
    selector: 'message-notification',
    templateUrl: './message-notification.component.html',
    styleUrls: ['./message-notification.component.scss']
})
export class MessageNotificationComponent implements OnInit {

    messageNotifications: INotificationMessage[] = [];
    subscription: Subscription;

    constructor(private notificationService: MessageService) {
        this.subscription = this.notificationService.getNotification().subscribe(message => {
            if (message && !message.isRemove && (message.ignoreDuplicate || !this.messageNotifications.some(item => item.text === message.text && item.customHtml === message.customHtml))) {
                this.messageNotifications.push(message);
                //BannerMessage default dismiss does not remove the element
                if (message.timeout && message.timeout > 0) {
                    setTimeout(() => this.dismissByItem(message), message.timeout);
                }
            } else if (message && message.isRemove) {
                this.dismissByItem(message);
                message.isRemove = false;
            }
        });
    }

    ngOnInit() {
    }

    dismissByItem(message: INotificationMessage) {
        // checking reference should be fine since we create a deep copy of the message that won't be impact
        this.messageNotifications = this.messageNotifications.filter(item => item.text !== message.text || item.customHtml !== message.customHtml);
    }

    // This should be triggered by both timeout call or close button
    dismiss(index: number) {
        this.messageNotifications.splice(index, 1);
    }

}
